import type { VDropdownProps } from '../VDropdown';
import { VDropdown } from '../VDropdown';
import { VFlex } from '../VFlex';
import { VStack } from '../VStack';
import { Backup, FileUpload } from '../asset';
import { DEFAULT_EMPTY_LIST_TEXT } from './constant';

const VFileBrowserEmptyContentList = ({
  btnUploadText,
  message,
  renderDropdownItem,
  onUploadButtonClick,
}: {
  btnUploadText?: string;
  message?: string;
  renderDropdownItem?: VDropdownProps['renderItem'];
  onUploadButtonClick?(type: 'directory' | 'file'): void;
}) => {
  return (
    <VStack className="py-40 text-secondary-300" items="center" gap={0.5}>
      <Backup className="h-16.5 w-16.5" />

      <div className="w-[394px] text-center text-body-l whitespace-pre-line">
        {(message ?? DEFAULT_EMPTY_LIST_TEXT.CONTENT_LIST).replaceAll(
          '\\n',
          '\n',
        )}
      </div>

      <div className="pt-2">
        <VDropdown
          itemList={[
            { value: 'directory', label: 'Upload folder' },
            { value: 'file', label: 'Upload file' },
          ]}
          renderItem={renderDropdownItem}
          onItemClick={e => onUploadButtonClick?.(e.target!.item.value)}
        >
          <VFlex gap={0.25} items="center">
            <FileUpload className="size-5" />
            {btnUploadText ?? 'Upload'}
          </VFlex>
        </VDropdown>
      </div>
    </VStack>
  );
};

export default VFileBrowserEmptyContentList;
